import { useEffect, useState } from 'react';
import { useIsFeatureEnabled } from '../../../features/feature-enablement/featureEnablement';

const LOCAL_STORAGE_KEY = 'navbarVisibility';
const LOCAL_STORAGE_OPTIONS = {
  visible: 'visible',
  hidden: 'hidden',
};

export const useNavBarVisibility = () => {
  const isZenModeAvailable = useIsFeatureEnabled('zen-mode');

  const [isVisible, setIsVisible] = useState(
    () =>
      localStorage.getItem(LOCAL_STORAGE_KEY) === LOCAL_STORAGE_OPTIONS.visible
  );

  useEffect(() => {
    localStorage.setItem(
      LOCAL_STORAGE_KEY,
      isVisible ? LOCAL_STORAGE_OPTIONS.visible : LOCAL_STORAGE_OPTIONS.hidden
    );
  }, [isVisible]);

  return {
    isVisible: !isZenModeAvailable ? true : isVisible,
    toggleVisibility: setIsVisible,
    isFeatureEnabled: isZenModeAvailable,
  };
};
